<template>
  <div class="asc-pdf-viewer-dialog">
    <asc-dialog
      :show-dialog="showDialog"
      :text="title"
      :width="1100"
      :on-close="handleClose"
    >
      <asc-spinner-wrapper :loading="loading">
        <asc-pdf-content-viewer
          v-if="pdfDocumentURL"
          :pdf-document="pdfDocumentURL"
        />
      </asc-spinner-wrapper>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscPdfContentViewer from '@/components/molecules/AscPdfContentViewer'

export default {
  name: 'AscPdfViewerDialog',

  components: {
    AscDialog,
    AscPdfContentViewer,
    AscSpinnerWrapper,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      default: 'PDF Viewer',
    },
    pdfDocumentURL: {
      type: String,
      required: true,
      default: '',
    },
  },
}
</script>
<style lang="scss">
.asc-pdf-viewer-dialog {
  position: relative;

  .asc-close-button {
    margin: 0 !important;
  }

  .asc-dialog {
    .v-card__text {
      padding: 0 16px 16px 16px !important;
    }
  }
}
</style>
